"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsGridSectionContainer = exports.isValidFaviconPath = exports.areResultsOverFiltered = exports.hasResultsForOfflineButtonRender = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var SearchFilters_1 = require("icf-search-client-data/lib/SearchFilters");
var OnlineOfflineMode_1 = require("icf-search-client-shared/lib/constants/OnlineOfflineMode");
var FeatureFlags_1 = require("icf-search-client-shared/lib/FeatureFlags");
var react_1 = require("react");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var ContestResultsSectionHeaderContainer_1 = require("./ContestResultsSectionHeaderContainer");
var PerformerDataSourceContext_1 = require("./PerformerDataSourceContext");
var SearchResultsGridHelpers_1 = require("./SearchResultsGridHelpers");
var SearchResultsGridSection_1 = require("./SearchResultsGridSection");
var SearchResultsSectionFooter_1 = require("./SearchResultsSectionFooter");
var SearchResultsSectionHeaderContainer_1 = require("./SearchResultsSectionHeaderContainer");
var ShowOfflineButtonContainer_1 = require("./ShowOfflineButtonContainer");
/**
 * Checking if we should display the show offline button before the grid. If there
 * are results returned, then we want to show the button before the grid. If there aren't results
 * the button is displayed in the header component
 */
var hasResultsForOfflineButtonRender = function (onlineOfflineMode, isFirstGrid, renderSecondaryGrid, isFallback, queryOptions) {
    return (renderSecondaryGrid &&
        onlineOfflineMode === OnlineOfflineMode_1.ONLINE_OFFLINE_MODE_ONLINE &&
        !(0, exports.areResultsOverFiltered)(isFallback, isFirstGrid, queryOptions.filters));
};
exports.hasResultsForOfflineButtonRender = hasResultsForOfflineButtonRender;
var areResultsOverFiltered = function (isFallback, isFirstGrid, filters) {
    return isFallback && isFirstGrid && (0, SearchFilters_1.getAdvancedFilterArray)(filters).length > 0;
};
exports.areResultsOverFiltered = areResultsOverFiltered;
var isValidFaviconPath = function (path) {
    var _a;
    return (_a = path === null || path === void 0 ? void 0 : path.toLowerCase().endsWith(".png")) !== null && _a !== void 0 ? _a : false;
};
exports.isValidFaviconPath = isValidFaviconPath;
var SearchResultsGridSectionContainer = /** @class */ (function (_super) {
    __extends(SearchResultsGridSectionContainer, _super);
    function SearchResultsGridSectionContainer(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this.state = {
            hasReset: false,
            isGridErrored: false,
            isLogoVerified: false,
            isOverFiltered: false,
            logoRef: (0, react_1.createRef)(),
            shouldHideBackToOnlineLinkInHeader: false,
        };
        return _this;
    }
    SearchResultsGridSectionContainer.prototype._renderHeader = function (dataSource, queryOptions, isFirstGrid) {
        var _a = this.props, currentCategory = _a.currentCategory, emitTrackingEvent = _a.emitTrackingEvent, isFiltersModalOpen = _a.isFiltersModalOpen, onFilterChange = _a.onFilterChange, onContestFilterChange = _a.onContestFilterChange, onlineOfflineMode = _a.onlineOfflineMode, onOfflineButtonClicked = _a.onOfflineButtonClicked, onOnlineButtonClicked = _a.onOnlineButtonClicked, openJoinModal = _a.openJoinModal, openMobileFilterModal = _a.openMobileFilterModal, onRemoveFilter = _a.onRemoveFilter, onThumbnailSizeChange = _a.onThumbnailSizeChange, setTotalPerformers = _a.setTotalPerformers, thumbnailSize = _a.thumbnailSize, toggleFiltersModal = _a.toggleFiltersModal, toggleSearch = _a.toggleSearch, setCategoryGroupIndex = _a.setCategoryGroupIndex, setCurrentCategory = _a.setCurrentCategory, categoryGroups = _a.categoryGroups, categoryGroupIndex = _a.categoryGroupIndex, setGenderPreference = _a.setGenderPreference, emitGenderTabEvent = _a.emitGenderTabEvent, pushRoute = _a.pushRoute;
        var shouldHideBackToOnlineLinkInHeader = this.state.shouldHideBackToOnlineLinkInHeader;
        var shouldHideOfflineButtonInHeader = queryOptions.type === "favorites";
        return queryOptions.type === "contest" ? (React.createElement(ContestResultsSectionHeaderContainer_1.ContestResultsSectionHeaderContainer, { emitTrackingEvent: emitTrackingEvent, onContestFilterChange: onContestFilterChange !== null && onContestFilterChange !== void 0 ? onContestFilterChange : (function () {
                /* no-op */
            }), queryOptions: queryOptions, resultsContext: dataSource.resultsContext.value })) : (
        // TODO: This is insane. Need to refactor.
        React.createElement(SearchResultsSectionHeaderContainer_1.SearchResultsSectionHeaderContainer, { currentCategory: currentCategory, emitTrackingEvent: emitTrackingEvent, isFiltersModalOpen: isFiltersModalOpen, isFirstGrid: isFirstGrid, isOverFiltered: (0, exports.areResultsOverFiltered)(dataSource.resultsContext.value.isFallback, isFirstGrid, queryOptions.filters), queryOptions: queryOptions, onFilterChange: onFilterChange !== null && onFilterChange !== void 0 ? onFilterChange : (function () {
                /* no-op */
            }), onlineOfflineMode: onlineOfflineMode, onOfflineButtonClicked: onOfflineButtonClicked, onOnlineButtonClicked: onOnlineButtonClicked, onRemoveFilter: onRemoveFilter, openJoinModal: openJoinModal, openMobileFilterModal: openMobileFilterModal, onThumbnailSizeChange: onThumbnailSizeChange, dataSource: dataSource, setTotalPerformers: setTotalPerformers, thumbnailSize: thumbnailSize, toggleFiltersModal: toggleFiltersModal, toggleSearch: toggleSearch, hideOfflineButton: shouldHideOfflineButtonInHeader, hideBackToOnlineLink: shouldHideBackToOnlineLinkInHeader, setCategoryGroupIndex: setCategoryGroupIndex, setCurrentCategory: setCurrentCategory, categoryGroups: categoryGroups, categoryGroupIndex: categoryGroupIndex, setGenderPreference: setGenderPreference, emitGenderTabEvent: emitGenderTabEvent, pushRoute: pushRoute }));
    };
    SearchResultsGridSectionContainer.prototype._shouldRenderSecondaryGrid = function (firstGridDataSource) {
        if (this._isGoldOnly() ||
            !(0, FeatureFlags_1.isFeatureFlagEnabled)("advanced_filters_enabled", this.props.skinConfig) ||
            firstGridDataSource.resultsContext.value.currentError ||
            !this._isFinalPageOfResults(firstGridDataSource) ||
            !this._isValidPathForSecondGrid(this.props.navigation.path) ||
            // TODO: Unsure how these can be undefined based on the default props
            !this.props.pageNumber ||
            !this.props.resultsPerPage ||
            !this.props.thumbnailSize) {
            return false;
        }
        return !this._isPageFull(firstGridDataSource);
    };
    SearchResultsGridSectionContainer.prototype._isGoldOnly = function () {
        var _a, _b;
        return ["enabled", "allowed"].includes((_b = (_a = this.props.skinConfig) === null || _a === void 0 ? void 0 : _a.global.gold_only_mode) !== null && _b !== void 0 ? _b : "disabled");
    };
    SearchResultsGridSectionContainer.prototype._isFinalPageOfResults = function (dataSource) {
        return (this.props.pageNumber >= Math.ceil(dataSource.resultsContext.value.totalItemCount / this.props.resultsPerPage));
    };
    SearchResultsGridSectionContainer.prototype._isValidPathForSecondGrid = function (pathname) {
        if (pathname === "/") {
            return true;
        }
        return ["/browse", "/search", "/page"].some(function (target) {
            return pathname.startsWith(target);
        });
    };
    SearchResultsGridSectionContainer.prototype._isPageFull = function (dataSource) {
        var columnCount = (0, SearchResultsGridHelpers_1.calculateColumnCount)(this.props.thumbnailSize);
        return (0, SearchResultsGridHelpers_1.calculateMissingRows)(this.props.resultsPerPage, columnCount, dataSource) <= 0;
    };
    SearchResultsGridSectionContainer.prototype._renderGridSectionContainer = function (dataOptions) {
        var _this = this;
        var _a;
        var genderFilter = (_a = dataOptions.queryOptions.filters) === null || _a === void 0 ? void 0 : _a.gender;
        if (dataOptions.queryOptions.type === "favorites") {
            // TODO: How does this work if filters is undefined?
            dataOptions.queryOptions.filters.gender = undefined;
        }
        return (React.createElement(PerformerDataSourceContext_1.PerformerDataSourceContext, { dataOptions: dataOptions, onResultsContextChanged: this.props.onResultsContextChanged, dataReceivedCallback: this._createDataReceivedCallback(dataOptions.queryOptions) }, function (dataSource) {
            var isOverFiltered = (0, exports.areResultsOverFiltered)(dataSource.resultsContext.value.isFallback, true, dataOptions.queryOptions.filters);
            var gridSectionDataOptions = isOverFiltered
                ? _this._prepareFallbackGridData(dataOptions, genderFilter)
                : dataOptions;
            _this._syncDataSourceWhenOverFiltered(isOverFiltered, dataSource);
            var shouldRenderOfflineButtonBeforeGrid = (0, exports.hasResultsForOfflineButtonRender)(_this.props.onlineOfflineMode, true, _this._shouldRenderSecondaryGrid(dataSource), dataSource.resultsContext.value.isFallback, gridSectionDataOptions.queryOptions) &&
                !_this.state.isGridErrored &&
                dataOptions.queryOptions.type !== "favorites";
            var shouldHideOfflineButtonInFooter = _this._shouldHideOfflineButton(dataSource) || _this.state.isGridErrored;
            var shouldRenderSecondaryGrid = _this._shouldRenderSecondaryGrid(dataSource);
            return (React.createElement("div", { "data-ta-locator": "GridSectionContainer" },
                _this._renderHeader(dataSource, dataOptions.queryOptions, true),
                _this._renderPrimaryGrid(dataSource, gridSectionDataOptions.queryOptions),
                shouldRenderOfflineButtonBeforeGrid ? (React.createElement(ShowOfflineButtonContainer_1.ShowOfflineButtonContainer, { onClick: _this.props.onOfflineButtonClicked })) : null,
                shouldRenderSecondaryGrid
                    ? _this._renderSecondaryGrid(_this._prepareSecondaryGridData(dataSource, dataOptions, genderFilter))
                    : null,
                React.createElement(SearchResultsSectionFooter_1.SearchResultsSectionFooter, __assign({}, _this.props, { queryOptions: dataOptions.queryOptions, resultsContext: dataSource.resultsContext.value, hideOfflineButton: shouldHideOfflineButtonInFooter }))));
        }));
    };
    SearchResultsGridSectionContainer.prototype._syncDataSourceWhenOverFiltered = function (isOverFiltered, dataSource) {
        if (this.state.isOverFiltered !== isOverFiltered && !this.state.hasReset) {
            this.setState({ isOverFiltered: isOverFiltered, hasReset: true });
            dataSource.reset();
        }
    };
    SearchResultsGridSectionContainer.prototype._prepareFallbackGridData = function (dataOptions, genderFilter) {
        var resultsPerPage = this.props.resultsPerPage;
        var secondaryDataOptions = this._prepareGridData(dataOptions, genderFilter);
        secondaryDataOptions.itemRange.start = 0;
        secondaryDataOptions.itemRange.end = resultsPerPage;
        return secondaryDataOptions;
    };
    SearchResultsGridSectionContainer.prototype._prepareGridData = function (dataOptions, genderFilter) {
        var _a;
        var secondaryDataOptions = (0, SearchResultsGridHelpers_1.propsToDataOptions)(this.props);
        if (dataOptions.fallbackData) {
            secondaryDataOptions.queryOptions = dataOptions.fallbackData.queryOptions;
        }
        if ((_a = dataOptions.queryOptions.filters) === null || _a === void 0 ? void 0 : _a.advanced) {
            secondaryDataOptions.queryOptions.notExactBoostedFilters = {
                advanced: dataOptions.queryOptions.filters.advanced,
            };
        }
        if (dataOptions.queryOptions.type === "favorites") {
            secondaryDataOptions.queryOptions.type = "favorites";
            secondaryDataOptions.queryOptions.filters.gender = genderFilter;
        }
        return secondaryDataOptions;
    };
    SearchResultsGridSectionContainer.prototype._createDataReceivedCallback = function (queryOptions) {
        var _a;
        if (!this.props.emitTrackingEvent) {
            return;
        }
        return (0, SearchResultsGridHelpers_1.emitSearchReceivedEvent)(this.props.emitTrackingEvent, this.props.eventPublisher, queryOptions, (_a = this.props.skinConfig.global.site) !== null && _a !== void 0 ? _a : 0, this.props.user.isAuthenticated);
    };
    SearchResultsGridSectionContainer.prototype._renderPrimaryGrid = function (dataSource, queryOptions) {
        var _this = this;
        return (React.createElement("div", { "data-ta-locator": "GridSection-first" },
            React.createElement(SearchResultsGridSection_1.SearchResultsGridSection, __assign({}, this.props, { breakpoint: this.props.layoutService.breakpoint, dataSource: dataSource, isFirstGrid: true, onlineOfflineMode: this.props.onlineOfflineMode, onOfflineButtonClicked: this.props.onOfflineButtonClicked, isLogoVerified: this.state.isLogoVerified, queryOptions: queryOptions, setIsGridErrored: function (isGridErrored) {
                    if (isGridErrored !== _this.state.isGridErrored) {
                        _this.setState({ isGridErrored: isGridErrored });
                    }
                }, translate: this.props.translationService.translate, onNoOnlineResultsRedirect: function () { return _this.setState({ shouldHideBackToOnlineLinkInHeader: true }); } }))));
    };
    SearchResultsGridSectionContainer.prototype._prepareSecondaryGridData = function (firstGridDataSource, dataOptions, genderFilter) {
        var _a = this.props, resultsPerPage = _a.resultsPerPage, thumbnailSize = _a.thumbnailSize;
        var secondaryDataOptions = this._prepareGridData(dataOptions, genderFilter);
        secondaryDataOptions.itemRange.start = 0;
        var columnCount = (0, SearchResultsGridHelpers_1.calculateColumnCount)(thumbnailSize);
        secondaryDataOptions.itemRange.end =
            columnCount * (0, SearchResultsGridHelpers_1.calculateMissingRows)(resultsPerPage, columnCount, firstGridDataSource);
        return secondaryDataOptions;
    };
    SearchResultsGridSectionContainer.prototype._renderSecondaryGrid = function (dataOptions) {
        var _this = this;
        dataOptions.includeFavorites = false;
        return (React.createElement(PerformerDataSourceContext_1.PerformerDataSourceContext, { dataOptions: dataOptions, dataReceivedCallback: this._createDataReceivedCallback(dataOptions.queryOptions) }, function (dataSource) {
            return (React.createElement("div", { "data-ta-locator": "GridSection-second" },
                _this._renderHeader(dataSource, dataOptions.queryOptions, false),
                React.createElement(SearchResultsGridSection_1.SearchResultsGridSection, __assign({}, _this.props, { breakpoint: _this.props.layoutService.breakpoint, onlineOfflineMode: _this.props.onlineOfflineMode, dataSource: dataSource, isFirstGrid: false, isLogoVerified: _this.state.isLogoVerified, queryOptions: dataOptions.queryOptions, translate: _this.props.translationService.translate }))));
        }));
    };
    SearchResultsGridSectionContainer.prototype._shouldHideOfflineButton = function (dataSource) {
        var _this = this;
        return (this._isGoldOnly() ||
            this._shouldRenderSecondaryGrid(dataSource) ||
            ["leaderboard", "favorites", "recents", "gold"].some(function (excludedPath) {
                return _this.props.navigation.path.includes(excludedPath);
            }));
    };
    SearchResultsGridSectionContainer.prototype.render = function () {
        var _this = this;
        var _a;
        var skinConfig = this.props.skinConfig;
        var logoRef = this.state.logoRef;
        return (React.createElement(React.Fragment, null,
            (0, exports.isValidFaviconPath)((_a = skinConfig.skin_theme) === null || _a === void 0 ? void 0 : _a.favicon_path) && (React.createElement("img", { crossOrigin: "anonymous", alt: "logo", "data-ta-locator": "logo_verifier", src: skinConfig.skin_theme.favicon_path, style: { display: "none" }, ref: logoRef, onLoad: 
                // testing image loading with canvas is extremely difficult in react
                /* istanbul ignore next */
                function () {
                    if (logoRef.current.width !== logoRef.current.height) {
                        // it must be a square
                        return;
                    }
                    var canvas = document.createElement("canvas");
                    var ctx = canvas.getContext("2d");
                    canvas.width = logoRef.current.width;
                    canvas.height = logoRef.current.height;
                    ctx.drawImage(logoRef.current, 0, 0);
                    var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
                    for (var j = 0; j < imgData.length; j += 4) {
                        if (imgData[j + 3] < 255) {
                            _this.setState({ isLogoVerified: true });
                            break;
                        }
                    }
                } })),
            this._renderGridSectionContainer((0, SearchResultsGridHelpers_1.propsToDataOptions)(this.props))));
    };
    SearchResultsGridSectionContainer.defaultProps = {
        itemCount: 48,
        pageNumber: 1,
        resultsPerPage: 48,
        showHeadlines: false,
    };
    SearchResultsGridSectionContainer = __decorate([
        (0, Ioc_1.connectContextsToProps)({
            layoutService: Contexts_1.ILayoutContext,
            logger: Contexts_1.ILoggerContext,
            skinConfig: Contexts_1.ISearchSkinConfigContext,
            // @ts-ignore -- Fix typing for contexts with undefined
            statsdClient: Contexts_1.IStatsdClientContext,
            translationService: Contexts_1.ITranslationServiceContext,
            user: Contexts_1.IUserContext,
            xmentService: Contexts_1.IXmentServiceContext,
            // @ts-ignore -- Fix typing for contexts with undefined
            eventPublisher: Contexts_1.IEventPublisherContext,
        })
    ], SearchResultsGridSectionContainer);
    return SearchResultsGridSectionContainer;
}(React.Component));
exports.SearchResultsGridSectionContainer = SearchResultsGridSectionContainer;
//# sourceMappingURL=SearchResultsGridSectionContainer.js.map